"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { classNames, Flex } from "@opensea/ui-kit";
import { Edit } from "@opensea/ui-kit/icons";
import { COLLECTION_PREVIEW_INTERACTIVE_ELEMENT_CLASS_NAME } from "@/components/collection/overview/constants";
import { useHeroHeaderView } from "@/components/hero-header/HeroHeaderViewProvider";
import { openBannerSidebar } from "@/components/studio/page-editor/utils";
export function CollectionHeaderPreviewActions() {
  const $ = _c(5);
  const {
    headerView
  } = useHeroHeaderView();
  const t0 = headerView === "compact" ? "top-auto bottom-[calc(100%+16px)]" : "top-6";
  let t1;
  if ($[0] !== t0) {
    t1 = classNames("absolute right-6 z-10 gap-2", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button className={classNames(COLLECTION_PREVIEW_INTERACTIVE_ELEMENT_CLASS_NAME)} icon={<Edit size={20} />} onClick={_temp} size="sm" variant="secondary" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <Flex className={t1}>{t2}</Flex>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp() {
  return openBannerSidebar();
}